import { ManageUsersPage } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

interface ManageStaffState {
  page: ManageUsersPage | null;
}

export const useManageStaffStore = create<ManageStaffState>(() => ({
  page: null,
}));
